/*
* @GpsTagUploadDialog.vue
* @description 描述
* @author CC
* @date 2025/09/20
*/

/* HTML */
<template>

    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item>
                    <span >筛选条件：</span>
                </el-form-item>
                <el-form-item prop="keyword">
                    <el-input v-model="searchForm.keyword" placeholder="请输入基站编号/序号" clearable :style="{width: '300px'}" @keyup.enter="search">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                    </el-input>
                </el-form-item>
            </el-form>


            <!-- 表格 -->
            <DynamicTable ref="dynamicTable"
                          :previewTitle="previewTitle"
                          :previewData="searchResult"
                          :selectBox="true"
                          :optionButton="false"
                          @selectRow="selectRow"
                          @selectRows="selectRows"
                          :key="dynamicTableKey"
                          :showSerialNumber="showSerialNumber"
            />

            <el-form v-if="dialogTreeItem.submitButton != ''" style="margin-bottom: 10px;">
                <el-form-item style="float: left;">
                    <div><span>已选中 </span><span style="font-weight: bold;">{{selectIds.length}}</span> <span>个</span></div>
                    <div v-if="selectIds.length>0"><span style="font-weight: bold;">选中：{{selectIds}}</span></div>
                </el-form-item>
                <el-form-item style="float: right; ">
                    <el-button type="primary" @click.native="submit" size="mini">{{dialogTreeItem.submitButton}}</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>

/* JS */
<script>

import DynamicTable from '@/components/DynamicTable.vue'

export default {
    /**
     * 组件名
     */
    name: "GpsTagUploadDialog",
    /**
     * 组件引用
     */
    components: {
        // 动态表格
        DynamicTable
    },

    /**
     * 数据接收类型
     */
    props: {

        /**
         * @Des 标题数据类型
         * @Auth CC
         * @Date 2025/09/20
         */
        previewTitle: {
            type: Array,
            default: function (){
                return []
            }
        },

        /**
         * @Des 表格数据类型
         * @Auth CC
         * @Date 2025/09/20
         */
        previewData: {
            type: Array,
            default: function (){
                return []
            }
        },

        /**
         * @Des 上传地址类型
         * @Auth CC
         * @Date 2025/09/20
         */
        uploadUrl: {
            type: String,
            default: function (){
                return ''
            }
        },

        /**
         * @Des 是否显示序号
         * @Auth CC
         * @Date 2025/09/20
         */
        showSerialNumber: {
            type: Boolean,
            default: function (){
                return true
            }
        },

        /**
         * @Des 是否显示序号
         * @Auth CC
         * @Date 2025/09/20
         */
        projectInfos: {
            type: Object,
            default: function (){
                return {}
            }
        }
    },

    /**
     * @Des 数据定义
     * @Auth CC
     * @Date 2025/09/20
     */
    data() {
        return{

            /**
             * @Des 弹出层属性
             * @Auth CC
             * @Date 2025/09/20
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            // 动态表格
            dynamicTableKey: 0,
            // 上传数据集合
            uploadData: [],
            // 选择的数量
            selectNum: 0,
            // 查询表单
            searchForm:{
                keyword: ""
            },
            // 查询结果
            searchResult: [],
            selectIds: [],
            operationLock: false,
            dataType: 0,
        }
    },
    /**
     * @Des 监听
     * @Auth
     * @Date 2025/09/20
     */
    watch: {
        /**
         * @Des 分页监听
         * @Auth
         * @Date 2025/09/20
         */
        searchForm: {
            handler(newVal, oldVal){
                this.search();
            },
            immediate: true,
            deep:true,
        }
    },

    /**
     * 方法定义
     */
    methods: {

        /**
         * @Description
         * @Param 筛选查询
         * @Auth CC
         * @Date 2025/09/20
         */
        search() {
            this.selectNum = 0;
            this.searchResult = [];
            if (this.searchForm.keyword == '') {
                this.searchResult = Object.assign([], this.previewData);
            } else {
                this.previewData.forEach((row, index) => {
                    if (row.short_sid.indexOf(this.searchForm.keyword) != -1
                        || row.localAddress.indexOf(this.searchForm.keyword) != -1
                    ) {
                        if (this.selectIds.indexOf(row.id) == -1) {
                            row.checked = false;
                        } else {
                            row.checked = true;
                        }
                        this.searchResult.push(row);
                    }
                })
            }
            this.dynamicTableKey++;
        },

        /**
         * @Description
         * @Param 打开弹窗
         * @Auth CC
         * @Date 2025/09/20
         */
        openDialog(title, button, type) {
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.dialogTreeItem.submitButton = button;
            this.dataType = type;
            this.searchResult = [];
            this.selectIds = [];
            this.$nextTick(() => {
                this.searchResult = Object.assign([], this.previewData);
                this.$refs.dynamicTable.cleanSelect();
            })
        },

        /**
         * @Des 关闭弹窗
         * @Auth CC
         * @Date 2025/09/20
         */
        handleDialogClose() {
            this.$refs.dynamicTable.cleanSelect();
            this.dialogTreeItem.dialogFormVisible = false;
            this.$emit("research");
        },

        /**
         * @Description
         * @Param 选择行处理
         * @Auth CC
         * @Date 2025/09/20
         */
        selectRow(row, selection) {
            if(!row.disabled){
                this.selectNum = selection.length;
                this.resetSelectId(selection);
            }
        },

        /**
         * @Description
         * @Param 选择多行处理
         * @Auth CC
         * @Date 2025/09/20
         */
        selectRows(rows) {
            // console.log(rows);
            this.selectNum = rows.length;
            this.resetSelectId(rows);
        },

        /**
         * @Description
         * @Param 重置选中的id
         * @Auth CC
         * @Date 2025/09/20
         */
        resetSelectId(rows) {
            // console.log(rows);
            // 新增id
            this.searchResult.forEach((r,i) => {
                let exist = false;
                rows.forEach((r2, i2) => {
                    if (r2.id == r.id) {
                        exist = true;
                        if (this.selectIds.indexOf(r.id) == -1) {
                            this.selectIds.push(r.id);
                            r.checked = true;
                        }
                    }
                });
                if (!exist) {
                    if(this.selectIds.indexOf(r.id) != -1){
                        this.selectIds.splice(this.selectIds.indexOf(r.id),1);
                        r.checked = false;
                    }
                }
            })
        },

        /**
         * @Description 数据提交
         * @Param
         * @Auth CC
         * @Date 2025/09/20
         */
        submit() {
            if (this.selectIds.length == 0) {
                this.$message({
                    message: '请选择数据',
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            if (this.uploadUrl == '') {
                this.$message({
                    message: '访问路径找不到！',
                    type: 'warning',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            if (this.selectIds.length == 0) {
                this.$message({
                    message: '未选中要修改的数据！',
                    type: 'warning',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            if (this.operationLock) return;
            this.operationLock = true;
            let num = 0;
            this.previewData.forEach((row, index) => {
                if (this.selectIds.indexOf(row.id) != -1) {
                    // console.log(this.uploadUrl)
                    this.$request.postJsonRequest(this.uploadUrl, row).then(result => {
                        num++;
                        if (this.dataType == 1) {
                            if (result.code == 0) {
                                row.message = '修改成功';
                            }
                            if (num == this.selectIds.length) {
                                this.operationLock = false;
                                this.$emit("research");
                                this.$refs.dynamicTable.cleanSelect();
                                this.$refs.dynamicTable.selectAll([]);
                            }
                        }
                    }).catch(error => {
                        num++;
                        row.message = '请求失败';
                        if (this.dataType == 1) {
                            if (num == this.selectIds.length) {
                                this.operationLock = false;
                                this.$emit("research");
                                this.$refs.dynamicTable.cleanSelect();
                                this.$refs.dynamicTable.selectAll([]);
                            }
                        }
                    });
                }
            })
        },
    },

}
</script>

/* CSS */
<style lang="scss" scoped>
/deep/ .form-dialog .el-select {
    width: auto;
}
/deep/ .form-dialog .el-form,
/deep/ .form-dialog .el-form-item {
    margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagUploadDialog.vue